import { IconAlertTriangle, IconBulb, IconExternalLink, IconFileText, IconHistory, IconMessageQuestion, type IconProps } from '@tabler/icons-react'
import { ElementType } from 'react'

import { AstraIcon, AstraParagraph, AstraTinyIndicator } from '~/astra'
import { useFlag } from '~/hooks/useFlag'

import { type SupportView } from './UserSupportDialog'

type MenuRowProps = {
    icon: ElementType<IconProps>
    label: string
    hint?: 'external'
    onClick: () => void
    indicator?: boolean
}

const MenuRow = ({ icon: Icon, label, hint, onClick, indicator }: MenuRowProps) => (
    <button
        type="button"
        className="flex h-10 w-full cursor-pointer items-center justify-between rounded-lg px-2 transition hover:bg-surface-backdrop/10"
        onClick={onClick}
    >
        <span className="flex min-w-0 items-center gap-2">
            <div className="relative inline-block">
                {indicator && <AstraTinyIndicator variant="brand" smallOffset placement="top-left" data-test="release-note-indicator" />}
                <AstraIcon icon={Icon} size="large" color="text-default" />
            </div>
            <AstraParagraph className="truncate text-start">{label}</AstraParagraph>
        </span>
        {hint === 'external' ? <AstraIcon icon={IconExternalLink} size="small" color="text-subtle" /> : null}
    </button>
)

type Props = {
    setActiveView: (view: SupportView) => void
    onOpenReleaseNote: () => void
    releaseNoteIndicator: boolean
}

export const UserSupportMenu = ({ setActiveView, onOpenReleaseNote, releaseNoteIndicator }: Props) => (
    <div className="flex flex-col gap-2">
        <section className="flex flex-col gap-2">
            <AstraParagraph variant="body-small" weight="medium" className="text-muted">
                Hjelp og tilbakemelding
            </AstraParagraph>
            <div className="flex flex-col gap-1">
                <MenuRow icon={IconAlertTriangle} label="Rapporter feil" onClick={() => setActiveView('bugReport')} />
                <MenuRow icon={IconMessageQuestion} label="Be om hjelp" onClick={() => setActiveView('helpRequest')} />
                <MenuRow icon={IconBulb} label="Foreslå forbedring" onClick={() => setActiveView('changeRequest')} />
            </div>
        </section>
        <section className="flex flex-col gap-2">
            <AstraParagraph variant="body-small" weight="medium" className="text-muted">
                Ressurser
            </AstraParagraph>
            <div className="flex flex-col gap-1">
                {useFlag('help__change_log_menu') && (
                    <MenuRow
                        icon={IconHistory}
                        label="Endringslogg"
                        onClick={onOpenReleaseNote}
                        data-test="release-note-menu-item"
                        indicator={releaseNoteIndicator}
                    />
                )}
                <MenuRow icon={IconFileText} label="Hjelpeartikler" hint="external" onClick={() => window.open('https://help.deepinsight.io', '_blank')} />
            </div>
        </section>
    </div>
)
